module.exports = __webpack_public_path__ + "static/media/attachment.3f6b9132.svg";